import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ModalService } from '@galaxy/atlas';
import { TranslateService } from '@ngx-translate/core';
import { SideNavigationLink } from '@vendasta/atlas';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, filter, map, shareReplay, startWith, take } from 'rxjs/operators';
import { BusinessNavConfigService } from '../../config.service';
import { UserRequiredModalComponent } from '../../modals/user-required/user-required.modal.component';
import { ProductLogoBankService } from '../../product-logo-bank.service';

@Component({
  selector: 'atlas-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
})
export class NavItemComponent implements OnInit {
  @Input() indentation: number;
  @Input({ required: true }) set item(item: SideNavigationLink) {
    this.link = item;
    this.childPaths = this.link.subLinks?.map((subLink) => subLink.path) ?? [];
  }
  text$: Observable<string>;
  curServiceProviderId: Observable<string>;
  isActive$: Observable<boolean>;

  protected link: SideNavigationLink;
  protected childPaths: string[];

  constructor(
    private router: Router,
    private t: TranslateService,
    private configService: BusinessNavConfigService,
    private productLogoBankService: ProductLogoBankService,
    private modalService: ModalService,
  ) {
    this.curServiceProviderId = this.configService.serviceProviderId$;

    this.isActive$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.url),
      startWith(this.router.url),
      map((curPath: string) => decodeURI(`/${this.router.parseUrl(curPath).root.children.primary.toString()}`)),
      map((curPath) => curPath === this.link.path || this.childPaths?.includes(curPath)),
      distinctUntilChanged(),
      shareReplay({ refCount: true, bufferSize: 1 }),
    );
  }

  ngOnInit(): void {
    if (!this.link.serviceProviderId) {
      this.curServiceProviderId.pipe(take(1)).subscribe((serviceProviderId: string) => {
        this.link.serviceProviderId = serviceProviderId;
      });
    }
    this.text$ = this.link.translationId ? this.t.stream(this.link.translationId) : of(this.link.label);
    if (this.link.logoUrl && this.link.serviceProviderId) {
      this.productLogoBankService.storeLogo(this.link.serviceProviderId, this.link.logoUrl);
    }
  }

  public calcIndentation(indentation: number): number {
    if (!indentation) {
      return 0;
    }
    if (this.link.showIcon) {
      return (indentation - 1) * 24;
    }
    return indentation * 24;
  }

  popUserRequiredModal(): void {
    this.modalService.openInformational(UserRequiredModalComponent);
  }
}
